// extracted by mini-css-extract-plugin
export default {"list":"styles_list__GFkL5","toggleButton":"styles_toggleButton__KOVLw","mobileLink":"styles_mobileLink__Mwqd2","nav":"styles_nav__rWGCn","showMobile":"styles_showMobile__ZsPN6"};